import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { List } from '../List';
export var useStyles = makeStyles(function () {
    return createStyles({
        root: {
            flexShrink: 0,
        },
        horizontal: {
            display: 'flex',
            '& li': {
                flexShrink: 0,
            },
        },
    });
});
var NavigationList = React.forwardRef(function (props, ref) {
    var _a;
    var classes = useStyles(props);
    var className = props.className, navTagAriaLabel = props.navTagAriaLabel, orientation = props.orientation, other = __rest(props, ["className", "navTagAriaLabel", "orientation"]);
    return (React.createElement("nav", { "aria-label": navTagAriaLabel, className: clsx(classes.root, className) },
        React.createElement(List, __assign({ disablePadding: true }, other, { ref: ref, className: clsx((_a = {},
                _a[classes.horizontal] = orientation === 'horizontal',
                _a['bb-ui-navigation-list-horizontal'] = orientation === 'horizontal',
                _a)) }))));
});
export default NavigationList;
//# sourceMappingURL=NavigationList.js.map